import React, { useState } from 'react'
import s from './RefundFlow.module.scss'
import ProfileMenuHeader from '../../ProfileMenuHeader'
import Button from 'components/shared/Button'
import { ReactComponent as Unchecked } from 'images/new-icons/unchecked_primary_radio_button.svg'
import { ReactComponent as Checked } from 'images/new-icons/checked_primary_radio_button.svg'

const reasons = [
  { id: 1, text: 'Failure to Meet Client Expectations' },
  { id: 2, text: 'Poor Quality Execution' },
  { id: 3, text: 'Allergic Reaction or Irritation' },
  { id: 4, text: 'Use of Low-Quality Materials' },
  { id: 5, text: 'Mistakes by the Technician' },
  { id: 6, text: 'Unsatisfactory Service' },
  { id: 7, text: 'Health Issues' }
]

const RefundReason = ({ onClose, onNext, refundReason, setRefundReason }) => {


  return (
    <div className={s.refund}>
      <ProfileMenuHeader
        text=''
        onClose={onClose}
      />
      <div className={s.reasons_title}>
        Why do you need to <br />
        refund?
      </div>

      <div className={s.reasons_list}>
        {reasons.map((reason) => (
          <div
            key={reason.id}
            className={s.reason_item}
            onClick={() => setRefundReason(reason.text)}
          >
            {refundReason === reason.text ? <Checked /> : <Unchecked />}
            <span className={s.reason_text}>{reason.text}</span>
          </div>
        ))}
      </div>

      <Button
        style={{ marginTop: '80px' }}
        wide
        darkGreen
        disabled={!refundReason}
        onClick={onNext}
      >
        Continue
      </Button>
    </div>
  )
}

export default RefundReason